/**
 * `EditablePair` — the special "Agent card · llms.txt" row that lives in
 * the Discoverable section between the fail rows and the collapsed
 * passing list. Both have inline editor drawers on readiness; the two
 * buttons jump straight there.
 */

import { useC } from '../../lib/theme.js';
import { sansFont } from './fonts.js';

export interface EditablePairProps {
  readonly cardHeadline: string;
  readonly cardEvidence: string;
  readonly llmsHeadline: string;
  readonly llmsEvidence: string;
  readonly onEditCard: () => void;
  readonly onEditLlms: () => void;
}

export function EditablePair({
  cardHeadline, cardEvidence,
  llmsHeadline, llmsEvidence,
  onEditCard, onEditLlms,
}: EditablePairProps): JSX.Element {
  const C = useC();
  return (
    <div
      className="flex flex-col gap-4 md:flex-row md:items-center md:gap-6"
      style={{ padding: '18px 24px', borderTop: `1px solid ${C.borderSoft}`, fontFamily: sansFont }}
    >
      <div className="flex-1 flex flex-col gap-4 md:flex-row md:gap-10 min-w-0">
        <div className="flex-1 min-w-0">
          <div style={{ fontSize: 15, color: C.text }}>{cardHeadline}</div>
          <div style={{ fontSize: 13, color: C.muted, marginTop: 4 }}>{cardEvidence}</div>
        </div>
        <div className="flex-1 min-w-0">
          <div style={{ fontSize: 15, color: C.text }}>{llmsHeadline}</div>
          <div style={{ fontSize: 13, color: C.muted, marginTop: 4 }}>{llmsEvidence}</div>
        </div>
      </div>
      <div className="flex gap-2 flex-shrink-0">
        <button
          type="button"
          onClick={onEditCard}
          aria-label="Edit agent card"
          style={{
            fontFamily: sansFont, fontSize: 13, padding: '7px 14px', minHeight: 44,
            background: 'transparent', color: C.text, border: `1px solid ${C.border}`, borderRadius: 3, cursor: 'pointer',
          }}
        >
          Edit card
        </button>
        <button
          type="button"
          onClick={onEditLlms}
          aria-label="Edit llms.txt"
          style={{
            fontFamily: sansFont, fontSize: 13, padding: '7px 14px', minHeight: 44,
            background: 'transparent', color: C.text, border: `1px solid ${C.border}`, borderRadius: 3, cursor: 'pointer',
          }}
        >
          Edit llms.txt
        </button>
      </div>
    </div>
  );
}
